import { render, staticRenderFns } from "./UserReportTable.vue?vue&type=template&id=6bc5f8a9&"
import script from "./UserReportTable.vue?vue&type=script&lang=js&"
export * from "./UserReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports